import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';

import { Icon } from '../Elements';

import classes from './SearchField.module.scss';

const SearchField = ({
  value = '',
  name,
  onChange,
  onClear,
  onSubmit,
  className,
  placeholder,
  textButton,
  errorText,
  isClearabled = false
}) => {
  const language = useUserState().user.language;

  return (
    <form onSubmit={onSubmit} className={cn(classes.searchField, className)}>
      <div className={classes.inputWrap}>
        <input
          type="text"
          name={name}
          value={value}
          onChange={onChange}
          placeholder={
            placeholder ? placeholder : t('searchField', 'ENTER_LINK', language)
          }
          className={cn(
            classes.searchInput,
            errorText && classes.searchInput_error
          )}
        />
        <Icon icon={'icn_Search'} className={classes.iconSearch} />
        {isClearabled && (
          <button onClick={onClear} className={classes.searchButton}>
            <Icon icon={'Icn_Clear'} className={classes.iconClear} />
          </button>
        )}
        {!isClearabled && (
          <button className={classes.searchButton} type={'submit'}>
            {textButton ? textButton : t('searchField', 'SEARCH', language)}
          </button>
        )}
      </div>
      {errorText && <p className={classes.errorText}>{errorText}</p>}
    </form>
  );
};

SearchField.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  textButton: PropTypes.string,
  errorText: PropTypes.string,
  isClearabled: PropTypes.bool
};

export default SearchField;
